import { api } from "assets/scripts/utilities/api-clients";

export const index = async ({
  params: { showMessage = false, ...restParams } = {},
  ...restOptions
} = {}) => {
  const response = await api.get("/kam/pdf-templates", {
    params: { showMessage, ...restParams },
    ...restOptions,
  });

  return response;
};
